import { KeyValue } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Store } from '@ngrx/store';
import { TranslateService } from "@ngx-translate/core";
import { JsonEditorOptions } from 'ang-jsoneditor';
import { combineLatest, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { sendTestPush } from '../../app.actions';
import { App, AppState, Tag, TestPush } from '../../app.models';

@Component({
  selector: 'app-test-push',
  templateUrl: './test-push.component.html',
  styleUrls: ['./test-push.component.scss']
})
export class TestPushComponent implements OnInit, OnDestroy {
  @Input() contextApp: App;
  @Input() contextTag: Tag;
  @ViewChild('editorInstance') editorInstance;
  storeData$: Subscription;
  selectedApps = [];
  selectedTags = [];
  selectedGroups = []
  filteredApps: App[];
  filteredTags: Tag[];
  filteredGroupTags: Tag[];
  payload = {
    title: 'Push Title',
    message: 'Push Message',
    url: 'https://www.example.com',
    'image.url': "https://www.example.com/image.jpg",
  };
  deviceIds = '';
  defaultPayloadOverride: boolean = null;

  get defaultPayload() {
    if (this.defaultPayloadOverride != null) {
      return this.defaultPayloadOverride;
    }
    else if (this.contextApp) {
      return this.contextApp.parameters.defaultPayload === 'true'
    } else if (this.contextTag) {
      return this.filteredApps.reduce((prev, curr) => {
        return prev && curr.parameters.defaultPayload === "true"
      }, true);
    }
  }
  set defaultPayload(val) {
    if (this.contextApp) {
      this.contextApp.parameters.defaultPayload = val ? 'true' : 'false';
    }
    this.defaultPayloadOverride = val;
  }
  editorOptions: JsonEditorOptions;


  constructor(
    private store: Store,
    private toastr: NbToastrService,
    @Optional() private dialogRef: NbDialogRef<TestPushComponent>,
    private translate: TranslateService
  ) {
    this.editorOptions = new JsonEditorOptions()
    this.editorOptions.mode = 'code'; //set only one mode
    this.editorOptions.mainMenuBar = false;
    this.editorOptions.statusBar = false;
  }

  get payloadJSON() {
    return JSON.stringify(this.payload);
  }
  set payloadJSON(val) {
    this.payload = JSON.parse(val);
  }

  get payloadKeys() {
    return Object.keys(this.payload)
  }

  ngOnInit(): void {

    const tags$ = this.store.select((state: AppState) => state.tags);
    const apps$ = this.store.select((state: AppState) => state.apps)
    this.storeData$ = combineLatest([apps$, tags$])
      .pipe(
        filter(([apps, tags]) => !!apps.length && !!tags.length)
      )
      .subscribe(([apps, tags]) => {
        if (this.contextApp) {
          this.selectedTags = apps
            .find(a => a.id === this.contextApp.id)
            .tags
            .map(t => t.id);
          this.selectedGroups = apps
            .find(a => a.id === this.contextApp.id)
            .groups
            .map(g => g.id);
          this.filteredTags = tags.filter(tag => (this.selectedGroups.includes(tag.parentId) && !tag.group) || this.selectedTags.includes(tag.id))
        }
        else if (this.contextTag) {
          this.selectedApps = apps
            .filter(app => app.tags.find(tag => tag.id === this.contextTag.id))
            .map(app => app.id);
          this.filteredApps = apps.filter(app => this.selectedApps.includes(app.id));
          console.log(this.filteredApps);

        }
      })
  }
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  close() {
    this.dialogRef.close();
  }

  push() {
    if (this.editorInstance && !this.editorInstance.isValidJson()) {
      this.toastr.danger(this.translate.instant('error_invalid_payload_json'));
      return;
    }

    const payload: TestPush = {
      appIds: this.contextApp ? [this.contextApp.id] : this.selectedApps,
      tagIds: this.contextTag ? [this.contextTag.id] : this.selectedTags,
      payload: JSON.stringify(this.payload),
      // deviceIds:""
    };
    if (this.deviceIds) {
      payload.deviceIds = this.deviceIds.replace(/\r\n/g, '\n')
        .split('\n')
        .map(e => `"${e}"`)
        .join();
    }


    this.store.dispatch(sendTestPush({ payload }))
    this.close();
  }

  ngOnDestroy() {
    this.storeData$.unsubscribe();
  }
}
